import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingIcon from './MeetingIcon';
import SenderSummary from './SenderSummary';
import { SenderPersonaWrapper } from 'owa-mail-sender-persona-view';

const styles = require('./MeetingMessageSummary.scss');

export interface SummaryRowProps {
    item: MeetingMessage;
    children?: any;
}

const SummaryRow: React.FunctionComponent<SummaryRowProps> = observer(props => {
    const { item } = props;

    return (
        <div className={styles.detailsRow}>
            <MeetingIcon message={item} className={styles.iconContainer} />
            <div className={styles.rowContent}>
                <SenderSummary
                    message={item}
                    senderPersona={
                        <SenderPersonaWrapper
                            message={item}
                            treatAsDraft={false}
                            isNodePending={false}
                            hideSMTP={false}
                            displayYouForSelf={true}
                            useIsReadStyle={true}
                            senderPersonaClassName={styles.sender}
                            className={styles.sender}
                        />
                    }
                />
                {props.children}
            </div>
        </div>
    );
});

export default SummaryRow;
